import React, {
  useState,
  Component
} from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import {
  Form
} from 'react-bootstrap';
import FooterPage from "../partials/footerPage";
import FooterShade from "../partials/footer";
import MD5 from "crypto-js/md5";
import Cookies from "universal-cookie";
const cookies = new Cookies();


class Standup extends Component {
  render() {

    if (!this.props.data.page) {
      return <p>...</p>;
    }
    //console.log(this.props.data.page);


    const images = this.props.data.page.standup.images.map((prop, i) => {
      //console.log(prop.sourceUrl);
      return (
        <div
          className={`carousel-item ${i === 0 ? "active" : ""}`}
          key={i}
          style={{
            backgroundImage: `url(${prop.sourceUrl})`
          }}
        ></div>
      );
    });
    //var i = 0;
    const CarouselIndicators = this.props.data.page.standup.images.map(
      (prop, i) => {
        //console.log(prop);

        return (
          <li
            data-target="#carouselId"
            data-slide-to={i}
            key={i}
            className={`${i === 0 ? "active" : ""}`}
          ></li>
        );
      }
    );
    //console.log(CarouselIndicators);

    const CheckoutForm = () => {
    const [pwdvalue, setpwdvalue] = useState('');
    
//console.log(pwdvalue.toString())
      //console.log(MD5(pwdvalue).toString() + ' ' + this.props.data.page.standup.password)
      var pwdtrue = false;
        
      (MD5(pwdvalue).toString() === this.props.data.page.standup.password) ? pwdtrue = true : pwdtrue = false;
      
      const ProtectedInfo = () => (<p dangerouslySetInnerHTML={{ __html: this.props.data.page.standup.pretectedDescriptionLv }} />);

      return pwdtrue === true ? (
              <>

          <ProtectedInfo />
                          
              </>
        
      ) : (
          <>
            <Form.Control type="password"
               value={pwdvalue} onInput={e => setpwdvalue(e.target.value)} placeholder="Parole">
          </Form.Control>
            </>
      );

    }


      // const reset = () => {
      //   setpwdvalue(false);
      // };

    return (
      <React.Fragment>
        <div>
        <div id = "singleStandup"
        className = "singlePage"
        data-headertitle = {
          cookies.get("lang") === "LV" ? this.props.data.page.title : cookies.get("lang") === "EN" ? this.props.data.page.translation.title : null
        }>
        <div id = "carouselId"
        className = "carousel slide narrow-carousel"
        data-ride = "carousel" >
          <div className="container m-0 p-0">
            <ol className="carousel-indicators">
              {CarouselIndicators.length > 1 ? CarouselIndicators : null}
            </ol>
          </div>

          <div className="carousel-inner" role="listbox">
            {images}
            <div className="carousel-item-herotextnarrow-wrap">
              <div className = "herotext herotext__morebottom" > {
                cookies.get("lang") === "LV" && this.props.data.page.title
              }
              {cookies.get("lang") === "EN" &&
                this.props.page.title}</div>
            </div>
          </div>
          <FooterShade />
        </div>
        <div className="container single-content-text">
        {/* <h2>{
          cookies.get("lang") === "LV" ? this.props.data.page.title : cookies.get("lang") === "EN" ? this.props.data.page.title : null
              }</h2> */}
          {cookies.get("lang") === "LV" ?
              <p dangerouslySetInnerHTML={{ __html: this.props.data.page.standup.descriptionLv }} />:
              <p dangerouslySetInnerHTML={{ __html: this.props.data.page.standup.descriptionLv }} />
              }
              <CheckoutForm />
        </div>
        </div>
          <FooterPage />
        </div>
      </React.Fragment>
    );
  }

}

const GetFAQBySlug = gql`
query standup {
  page(id: "cG9zdDoxNDM1") {
    title(format: RENDERED)
    standup {
      descriptionLv
      images {
        sourceUrl(size: LARGE)
      }
      password
      pretectedDescriptionLv
    }
  }
}
`;

export default graphql(GetFAQBySlug)(Standup);
